// extracted by mini-css-extract-plugin
export var required = "_hp-0";